import * as React from "react";
const SvgSearchResultsArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 10 6"
    {...props}
  >
    <path
      stroke="#645FE6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M.75 2.678h8.485M7.307 4.607l1.928-1.929L7.307.75"
    />
  </svg>
);
export default SvgSearchResultsArrowIcon;
